import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import Menu from 'vibo-ui/Menu';
import ClickAwayListener from 'vibo-ui/ClickAwayListener';

import { getSelectedDevToolsMenuKeys } from 'services/common/routesHelper';

import { IconmoonFont } from 'vibo-ui/Icon';

import useStyles from './style';

const DevToolsMenu: FC = () => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const toggleOpenMenu = () => setIsOpen(prev => !prev);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <Menu.Item
        onMouseDown={toggleOpenMenu}
        icon={IconmoonFont['devTools-24']}
        title="Dev tools"
        key="/devTools"
      >
        <span>Dev tools</span>
      </Menu.Item>
      <Menu
        className={classNames('siderSubMenu', classes.siderSubMenu, {
          isOpen,
        })}
        getSelectedSidebarMenuKeys={getSelectedDevToolsMenuKeys}
        styleModificator="siderLeft"
        selectedKeys={[]}
      >
        <Menu.Item
          onClick={() => navigate('/health-check')}
          icon={IconmoonFont['halthCheck-16']}
          title="Health check"
          key="/health-check"
        >
          <span>Health check</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => navigate('/web-hook-test')}
          icon={IconmoonFont['webHookAi-16']}
          key="/web-hook-test"
          title="WebHook"
        >
          <span>WebHook</span>
        </Menu.Item>
      </Menu>
    </ClickAwayListener>
  );
};

export default DevToolsMenu;
